import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
// import Header from "../InitialPage/Sidebar/Header";
// import Sidebar from "../InitialPage/Sidebar/Sidebar";
import ModernLayout from "../InitialPage/ModernLayout";
import { menuRoute, pagesRoute, publicRoutes } from "./router.link";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import MenuHeader from "../InitialPage/Sidebar/MenuHeader";
import SubscriptionSuccess from "../feature-module/pages/pricing/SubscriptionSuccess.jsx";

// Lazy load du composant UpdateNotification pour optimiser les performances
const UpdateNotification = lazy(() => import("../components/UpdateNotification/UpdateNotification.jsx"));

const AllRoutes = () => {
  const data = useSelector((state) => state.toggle_header);
  // const HeaderLayout = () => ( 
  //   <div className={`main-wrapper ${data ? "header-collapse" : ""}`}>
  //   {/* <Loader /> */}
  //   <Header />
  //   <Sidebar />
  //   <Outlet />
  // </div>
  // );

  const Authpages = () => (
    <div className={data ? "header-collapse" : ""}>
      <Outlet />
      {/* <Loader /> */}
    </div>
  );

  const MenuLayout = () => (
    <div style={{ paddingTop: '60px', minHeight: '100vh' }}>
      <MenuHeader />
      <Outlet />
    </div>
  );

  return (
    <div>
      {/* Notification de mise à jour - Lazy loaded pour performance optimale */}
      <Suspense fallback={null}>
        <UpdateNotification />
      </Suspense>

      <Routes>
        {/* Route directe pour le succès d'abonnement Stripe */}
        <Route path="/subscription-success" element={<SubscriptionSuccess />} />
        
        <Route path="/" element={<ModernLayout />}>
          {publicRoutes.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>

        <Route path={"/"} element={<MenuLayout />}>
          {menuRoute.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>

        <Route path={"/"} element={<Authpages />}>
          {pagesRoute.map((route, id) => (
            <Route path={route.path} element={route.element} key={id} />
          ))}
        </Route>
      </Routes>
    </div>
  );
};
export default AllRoutes;
